import { Component, HostListener, Inject, Input } from '@angular/core';
import { filter, fromEvent, map, merge, skip, throttleTime } from 'rxjs';
import { NavigationComponent, PermissionKey } from '../../shared';
import { MembershipsChange, PermissionsState } from '../../shared/state';
import { ofActionSuccessful } from '@ngxs/store';
import { InactivityCountdownComponent } from './inactivity-countdown/inactivity-countdown.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as i0 from "@angular/core";
import * as i1 from "@ngx-translate/core";
import * as i2 from "@angular/cdk/layout";
import * as i3 from "@angular/router";
import * as i4 from "../../shared";
import * as i5 from "../../complex-components/basic-grid";
import * as i6 from "@ngxs/store";
import * as i7 from "./services/login.service";
import * as i8 from "./services/inactivity.service";
import * as i9 from "../../basic-features";
import * as i10 from "./services/msal-auth-facade.service";
import * as i11 from "../contact-form-sidemodal";
import * as i12 from "./services/system-message.service";
import * as i13 from "./services/header-ngxs.service";
import * as i14 from "@angular/common";
import * as i15 from "../../basic-features/icon-v2/icon.component";
import * as i16 from "primeng/tooltip";
import * as i17 from "../../basic-features/button-v2/button.component";
import * as i18 from "../notifications-v2/notifications-count-v2/notifications-count-v2.component";
import * as i19 from "../notifications-v2/notifications-sidebar-v2/notifications-sidebar-v2.component";
import * as i20 from "../../shared/directive/tooltip-on-ellipsis-v2.directive";
import * as i21 from "../../shared/directive/on-outside-click.directive";
import * as i22 from "../../basic-features/banner/banner.component";
import * as i23 from "../../basic-features/dialog-v2/dialog-v2.component";
import * as i24 from "../../basic-features/snackbar/snackbar.component";
import * as i25 from "../../basic-features/link-v2/link-v2.component";
import * as i26 from "../contact-form-sidemodal/contact-form-side-modal.component";
import * as i27 from "../../basic-features/complex-dialog-v2/complex-dialog-v2.component";
import * as i28 from "../system-status-dialog/system-status-dialog.component";
import * as i29 from "./environment-tag/environment-tag.component";
import * as i30 from "./pipes/check-if-permission-missing.pipe";
const _forTrack0 = ($index, $item) => $item.nameKey;
const _c0 = a0 => ({
  "mobile-container": a0
});
const _c1 = a0 => ({
  "burger-icon-hover": a0
});
const _c2 = () => ({
  height: "240px",
  right: "140px"
});
const _c3 = a0 => ({
  "admin-background": a0
});
const _c4 = a0 => ({
  "gea-font-white": a0
});
const _c5 = () => ({
  "margin-right": "4px"
});
function HeaderComponent_div_0_geaui_icon_v2_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "geaui-icon-v2", 29);
    i0.ɵɵlistener("click", function HeaderComponent_div_0_geaui_icon_v2_3_Template_geaui_icon_v2_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.canOpenBurgerMenu ? ctx_r1.toggleBurgerMenu() : undefined);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c1, ctx_r1.canOpenBurgerMenu));
  }
}
function HeaderComponent_div_0_geaui_icon_v2_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "geaui-icon-v2", 30);
    i0.ɵɵlistener("click", function HeaderComponent_div_0_geaui_icon_v2_4_Template_geaui_icon_v2_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.toggleMobileSidebar());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("file", ctx_r1.mobileSidebarOpen ? "24px_close" : "24px_burgermenu");
  }
}
function HeaderComponent_div_0_img_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "img", 31);
    i0.ɵɵlistener("error", function HeaderComponent_div_0_img_5_Template_img_error_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onLogoError());
    })("click", function HeaderComponent_div_0_img_5_Template_img_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.goToPortal());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("src", ctx_r1.imageService.getLogo(), i0.ɵɵsanitizeUrl)("alt", "GEA");
  }
}
function HeaderComponent_div_0_div_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 32)(1, "img", 33);
    i0.ɵɵlistener("error", function HeaderComponent_div_0_div_6_Template_img_error_1_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onLogoError());
    })("click", function HeaderComponent_div_0_div_6_Template_img_click_1_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.goToPortal());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", ctx_r1.imageService.getLogo(), i0.ɵɵsanitizeUrl)("alt", "GEA");
  }
}
function HeaderComponent_div_0_span_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 34);
    i0.ɵɵtext(1, "GEA");
    i0.ɵɵelementEnd();
  }
}
function HeaderComponent_div_0_div_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35)(1, "span", 36);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.headerTitle);
  }
}
function HeaderComponent_div_0_Conditional_13_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 39);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r1.shoppingCartBadge));
  }
}
function HeaderComponent_div_0_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵlistener("click", function HeaderComponent_div_0_Conditional_13_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.navigateToCart());
    });
    i0.ɵɵelement(1, "geaui-icon-v2", 38);
    i0.ɵɵtemplate(2, HeaderComponent_div_0_Conditional_13_Conditional_2_Template, 3, 3, "span", 39);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.shoppingCartBadge ? 2 : -1);
  }
}
function HeaderComponent_div_0_div_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 40);
    i0.ɵɵlistener("click", function HeaderComponent_div_0_div_14_Template_div_click_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.toggleLanguageMenu($event));
    });
    i0.ɵɵelementStart(1, "span", 41);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "geaui-icon-v2", 42);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, "X.LANGUAGE." + ctx_r1.translate.currentLang.toUpperCase()));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("file", ctx_r1.currentShowDropdown === "language" ? "16px_chevron-up" : "16px_chevron-down");
  }
}
function HeaderComponent_div_0_div_15_For_2_geaui_link_v2_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "geaui-link-v2", 46);
    i0.ɵɵlistener("click", function HeaderComponent_div_0_div_15_For_2_geaui_link_v2_0_Template_geaui_link_v2_click_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const lang_r9 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onLanguageChange(lang_r9.value));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const lang_r9 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "X.LANGUAGE." + lang_r9.name), " ");
  }
}
function HeaderComponent_div_0_div_15_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HeaderComponent_div_0_div_15_For_2_geaui_link_v2_0_Template, 3, 3, "geaui-link-v2", 45);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngIf", !ctx_r1.noAuth || ctx_r1.isAdmin);
  }
}
function HeaderComponent_div_0_div_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 43);
    i0.ɵɵrepeaterCreate(1, HeaderComponent_div_0_div_15_For_2_Template, 1, 1, "geaui-link-v2", 44, _forTrack0);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(4, _c2));
    i0.ɵɵadvance();
    i0.ɵɵrepeater(i0.ɵɵpipeBind1(3, 2, ctx_r1.languages$));
  }
}
function HeaderComponent_div_0_geaui_notifications_count_v2_16_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "geaui-notifications-count-v2", 47);
    i0.ɵɵlistener("clicked", function HeaderComponent_div_0_geaui_notifications_count_v2_16_Template_geaui_notifications_count_v2_clicked_0_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.showNotifications = !ctx_r1.showNotifications);
    });
    i0.ɵɵelementEnd();
  }
}
function HeaderComponent_div_0_div_17_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 48);
    i0.ɵɵlistener("click", function HeaderComponent_div_0_div_17_Template_div_click_0_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.toggleMenu($event));
    });
    i0.ɵɵelement(1, "geaui-icon-v2", 49);
    i0.ɵɵelementStart(2, "span", 50);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "geaui-icon-v2", 51);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c3, ctx_r1.headerNgxsService.currentUserContext === "TEMP_MEMBERSHIP"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("color", ctx_r1.headerNgxsService.currentUserContext === "TEMP_MEMBERSHIP" ? "black" : "white")("file", ctx_r1.isAdmin || ctx_r1.headerNgxsService.currentUserContext === "TEMP_MEMBERSHIP" ? "24px_office" : "24px_profile");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c4, ctx_r1.headerNgxsService.currentUserContext !== "TEMP_MEMBERSHIP"));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 7, ctx_r1.headerNgxsService.userName || (ctx_r1.isAdmin ? "UI-LIB.HEADER.USER_MENU.GEA_ADMIN_LOGIN_FALLBACK" : "")), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("file", ctx_r1.currentShowDropdown === "profile" ? "16px_chevron-up" : "16px_chevron-down")("color", ctx_r1.headerNgxsService.currentUserContext === "TEMP_MEMBERSHIP" ? "black" : "white");
  }
}
function HeaderComponent_div_0_div_18_Conditional_1_geaui_link_v2_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "geaui-link-v2", 55);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("disabled", true);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(2, 3, "X.LABEL.ORGANISATION"), ": ", ctx_r1.headerNgxsService.tempUserMembership.name, " ");
  }
}
function HeaderComponent_div_0_div_18_Conditional_1_geaui_link_v2_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "geaui-link-v2", 55);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("disabled", true);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(2, 3, "X.LABEL.ROLE"), " : ", i0.ɵɵpipeBind1(3, 5, ctx_r1.headerNgxsService.tempUserMembership.roles[0] ? "X.ROLE." + ctx_r1.headerNgxsService.tempUserMembership.roles[0].toUpperCase() : ""), " ");
  }
}
function HeaderComponent_div_0_div_18_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HeaderComponent_div_0_div_18_Conditional_1_geaui_link_v2_0_Template, 3, 5, "geaui-link-v2", 54)(1, HeaderComponent_div_0_div_18_Conditional_1_geaui_link_v2_1_Template, 4, 7, "geaui-link-v2", 54);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngIf", !ctx_r1.isAdmin && ctx_r1.loginDisplay);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isAdmin && ctx_r1.loginDisplay);
  }
}
function HeaderComponent_div_0_div_18_Conditional_2_geaui_link_v2_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "geaui-link-v2", 57);
    i0.ɵɵpipe(1, "checkIfPermissionMissing");
    i0.ɵɵlistener("click", function HeaderComponent_div_0_div_18_Conditional_2_geaui_link_v2_0_Template_geaui_link_v2_click_0_listener() {
      i0.ɵɵrestoreView(_r12);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.openProfile());
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("disabled", i0.ɵɵpipeBind2(1, 2, ctx_r1.userPermissions, ctx_r1.permissionKey.READ_OWN_PROFILE));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 5, "UI-LIB.HEADER.PROFILE"), " ");
  }
}
function HeaderComponent_div_0_div_18_Conditional_2_geaui_link_v2_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "geaui-link-v2", 57);
    i0.ɵɵpipe(1, "checkIfPermissionMissing");
    i0.ɵɵlistener("click", function HeaderComponent_div_0_div_18_Conditional_2_geaui_link_v2_1_Template_geaui_link_v2_click_0_listener() {
      i0.ɵɵrestoreView(_r13);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.openUserAdmin());
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("disabled", i0.ɵɵpipeBind2(1, 2, ctx_r1.userPermissions, ctx_r1.permissionKey.READ_USER_LIST));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 5, "UI-LIB.HEADER.USER"), " ");
  }
}
function HeaderComponent_div_0_div_18_Conditional_2_geaui_link_v2_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "geaui-link-v2", 57);
    i0.ɵɵpipe(1, "checkIfPermissionMissing");
    i0.ɵɵlistener("click", function HeaderComponent_div_0_div_18_Conditional_2_geaui_link_v2_2_Template_geaui_link_v2_click_0_listener() {
      i0.ɵɵrestoreView(_r14);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.openOrgaAdmin());
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("disabled", i0.ɵɵpipeBind2(1, 2, ctx_r1.userPermissions, ctx_r1.permissionKey.READ_ORGANIZATION_LIST));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 5, "UI-LIB.HEADER.ORGA"), " ");
  }
}
function HeaderComponent_div_0_div_18_Conditional_2_geaui_link_v2_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "geaui-link-v2", 57);
    i0.ɵɵpipe(1, "checkIfPermissionMissing");
    i0.ɵɵlistener("click", function HeaderComponent_div_0_div_18_Conditional_2_geaui_link_v2_3_Template_geaui_link_v2_click_0_listener() {
      i0.ɵɵrestoreView(_r15);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.openNotificationSettings());
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("disabled", i0.ɵɵpipeBind2(1, 2, ctx_r1.userPermissions, ctx_r1.permissionKey.NOTIFICATION_SETTINGS_ACCESS));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 5, "UI-LIB.HEADER.NOTIFICATION"), " ");
  }
}
function HeaderComponent_div_0_div_18_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HeaderComponent_div_0_div_18_Conditional_2_geaui_link_v2_0_Template, 4, 7, "geaui-link-v2", 56)(1, HeaderComponent_div_0_div_18_Conditional_2_geaui_link_v2_1_Template, 4, 7, "geaui-link-v2", 56)(2, HeaderComponent_div_0_div_18_Conditional_2_geaui_link_v2_2_Template, 4, 7, "geaui-link-v2", 56)(3, HeaderComponent_div_0_div_18_Conditional_2_geaui_link_v2_3_Template, 4, 7, "geaui-link-v2", 56);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngIf", !ctx_r1.isAdmin && ctx_r1.loginDisplay);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isAdmin && ctx_r1.loginDisplay);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isAdmin && ctx_r1.loginDisplay);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isAdmin && ctx_r1.loginDisplay);
  }
}
function HeaderComponent_div_0_div_18_geaui_link_v2_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "geaui-link-v2", 58);
    i0.ɵɵlistener("click", function HeaderComponent_div_0_div_18_geaui_link_v2_3_Template_geaui_link_v2_click_0_listener() {
      i0.ɵɵrestoreView(_r16);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.loginService.login());
    });
    i0.ɵɵelement(1, "geaui-icon-v2", 59);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "UI-LIB.HEADER.LOGIN"), " ");
  }
}
function HeaderComponent_div_0_div_18_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 60);
  }
}
function HeaderComponent_div_0_div_18_geaui_link_v2_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "geaui-link-v2", 58);
    i0.ɵɵlistener("click", function HeaderComponent_div_0_div_18_geaui_link_v2_5_Template_geaui_link_v2_click_0_listener() {
      i0.ɵɵrestoreView(_r17);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.logout());
    });
    i0.ɵɵelement(1, "geaui-icon-v2", 61);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "UI-LIB.HEADER.LOGOUT"), " ");
  }
}
function HeaderComponent_div_0_div_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 43);
    i0.ɵɵtemplate(1, HeaderComponent_div_0_div_18_Conditional_1_Template, 2, 2)(2, HeaderComponent_div_0_div_18_Conditional_2_Template, 4, 4)(3, HeaderComponent_div_0_div_18_geaui_link_v2_3_Template, 4, 3, "geaui-link-v2", 52)(4, HeaderComponent_div_0_div_18_div_4_Template, 1, 0, "div", 53)(5, HeaderComponent_div_0_div_18_geaui_link_v2_5_Template, 4, 3, "geaui-link-v2", 52);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.headerNgxsService.currentUserContext !== "PORTAL_USER" ? 1 : 2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r1.loginDisplay);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isAdmin && ctx_r1.loginDisplay);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.loginDisplay);
  }
}
function HeaderComponent_div_0_geaui_icon_v2_19_Template(rf, ctx) {
  if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "geaui-icon-v2", 62);
    i0.ɵɵlistener("click", function HeaderComponent_div_0_geaui_icon_v2_19_Template_geaui_icon_v2_click_0_listener() {
      i0.ɵɵrestoreView(_r18);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.loginDisplay || !ctx_r1.disableLoginMobile || !ctx_r1.disableSignupMobile ? ctx_r1.showMobileProfile = !ctx_r1.showMobileProfile : undefined);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("file", ctx_r1.showMobileProfile ? "24px_close" : ctx_r1.headerNgxsService.currentUserContext === "PORTAL_USER" || !ctx_r1.headerNgxsService.currentUserContext ? "24px_profile" : "24px_office");
  }
}
function HeaderComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9)(1, "div", 10)(2, "div", 11);
    i0.ɵɵtemplate(3, HeaderComponent_div_0_geaui_icon_v2_3_Template, 1, 3, "geaui-icon-v2", 12)(4, HeaderComponent_div_0_geaui_icon_v2_4_Template, 1, 1, "geaui-icon-v2", 13)(5, HeaderComponent_div_0_img_5_Template, 1, 2, "img", 14)(6, HeaderComponent_div_0_div_6_Template, 2, 2, "div", 15)(7, HeaderComponent_div_0_span_7_Template, 2, 0, "span", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 17);
    i0.ɵɵelement(9, "geaui-environment-tag", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, HeaderComponent_div_0_div_10_Template, 3, 1, "div", 19);
    i0.ɵɵelementStart(11, "div", 20)(12, "div", 21);
    i0.ɵɵtemplate(13, HeaderComponent_div_0_Conditional_13_Template, 3, 1, "div", 22)(14, HeaderComponent_div_0_div_14_Template, 5, 4, "div", 23)(15, HeaderComponent_div_0_div_15_Template, 4, 5, "div", 24)(16, HeaderComponent_div_0_geaui_notifications_count_v2_16_Template, 1, 0, "geaui-notifications-count-v2", 25)(17, HeaderComponent_div_0_div_17_Template, 6, 13, "div", 26)(18, HeaderComponent_div_0_div_18_Template, 6, 4, "div", 27)(19, HeaderComponent_div_0_geaui_icon_v2_19_Template, 1, 1, "geaui-icon-v2", 28);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(15, _c0, ctx_r1.mobileView));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r1.mobileView);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.mobileView);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.mobileView && !ctx_r1.isLogoError);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.mobileView && !ctx_r1.isLogoError);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isLogoError);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("isMobile", ctx_r1.mobileView);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.mobileView);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r1.shoppingCartUrl.length ? 13 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.mobileView && ctx_r1.showLangDropdown);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.currentShowDropdown === "language");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isAdmin && ctx_r1.loginDisplay);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.mobileView);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.currentShowDropdown === "profile");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.mobileView);
  }
}
function HeaderComponent_Conditional_1_For_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 66);
    i0.ɵɵelement(1, "img", 67);
    i0.ɵɵelementStart(2, "div", 68);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const app_r20 = ctx.$implicit;
    i0.ɵɵproperty("href", app_r20.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", app_r20.imagePath, i0.ɵɵsanitizeUrl)("alt", app_r20.appKey);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("pTooltip", i0.ɵɵpipeBind1(3, 5, "APPS." + app_r20.appKey + ".WIDGETS.APP_LINK.NAME"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 7, "APPS." + app_r20.appKey + ".WIDGETS.APP_LINK.NAME"), " ");
  }
}
function HeaderComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 63);
    i0.ɵɵlistener("outSideClick", function HeaderComponent_Conditional_1_Template_div_outSideClick_0_listener() {
      i0.ɵɵrestoreView(_r19);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1._showBurgerMenu = false);
    });
    i0.ɵɵelementStart(1, "div", 64);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 65);
    i0.ɵɵrepeaterCreate(4, HeaderComponent_Conditional_1_For_5_Template, 6, 9, "a", 66, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.headerNgxsService.availableApps);
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r1.headerNgxsService.appList);
  }
}
function HeaderComponent_geaui_notifications_sidebar_v2_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "geaui-notifications-sidebar-v2", 69);
    i0.ɵɵlistener("closed", function HeaderComponent_geaui_notifications_sidebar_v2_3_Template_geaui_notifications_sidebar_v2_closed_0_listener() {
      i0.ɵɵrestoreView(_r21);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.showNotifications = false);
    });
    i0.ɵɵelementEnd();
  }
}
function HeaderComponent_div_4_Conditional_1_Conditional_7_geaui_link_v2_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "geaui-link-v2", 80);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("disabled", true);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(2, 3, "X.LABEL.ORGANISATION"), ": ", ctx_r1.headerNgxsService.tempUserMembership.name, " ");
  }
}
function HeaderComponent_div_4_Conditional_1_Conditional_7_geaui_link_v2_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "geaui-link-v2", 80);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("disabled", true);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(2, 3, "X.LABEL.ROLE"), ": ", i0.ɵɵpipeBind1(3, 5, ctx_r1.headerNgxsService.tempUserMembership.roles[0] ? "X.ROLE." + ctx_r1.headerNgxsService.tempUserMembership.roles[0].toUpperCase() : ""), " ");
  }
}
function HeaderComponent_div_4_Conditional_1_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HeaderComponent_div_4_Conditional_1_Conditional_7_geaui_link_v2_0_Template, 3, 5, "geaui-link-v2", 79)(1, HeaderComponent_div_4_Conditional_1_Conditional_7_geaui_link_v2_1_Template, 4, 7, "geaui-link-v2", 79);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngIf", !ctx_r1.isAdmin);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isAdmin);
  }
}
function HeaderComponent_div_4_Conditional_1_Conditional_8_span_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 83);
    i0.ɵɵpipe(1, "checkIfPermissionMissing");
    i0.ɵɵlistener("click", function HeaderComponent_div_4_Conditional_1_Conditional_8_span_0_Template_span_click_0_listener() {
      i0.ɵɵrestoreView(_r23);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.openProfile());
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵclassProp("disabled", i0.ɵɵpipeBind2(1, 3, ctx_r1.userPermissions, ctx_r1.permissionKey.READ_OWN_PROFILE));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 6, "UI-LIB.HEADER.PROFILE"), " ");
  }
}
function HeaderComponent_div_4_Conditional_1_Conditional_8_span_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 83);
    i0.ɵɵpipe(1, "checkIfPermissionMissing");
    i0.ɵɵlistener("click", function HeaderComponent_div_4_Conditional_1_Conditional_8_span_1_Template_span_click_0_listener() {
      i0.ɵɵrestoreView(_r24);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.openUserAdmin());
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵclassProp("disabled", i0.ɵɵpipeBind2(1, 3, ctx_r1.userPermissions, ctx_r1.permissionKey.READ_USER_LIST));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 6, "UI-LIB.HEADER.USER"), " ");
  }
}
function HeaderComponent_div_4_Conditional_1_Conditional_8_span_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 83);
    i0.ɵɵpipe(1, "checkIfPermissionMissing");
    i0.ɵɵlistener("click", function HeaderComponent_div_4_Conditional_1_Conditional_8_span_2_Template_span_click_0_listener() {
      i0.ɵɵrestoreView(_r25);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.openOrgaAdmin());
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵclassProp("disabled", i0.ɵɵpipeBind2(1, 3, ctx_r1.userPermissions, ctx_r1.permissionKey.READ_ORGANIZATION_LIST));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 6, "UI-LIB.HEADER.ORGA"), " ");
  }
}
function HeaderComponent_div_4_Conditional_1_Conditional_8_span_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 83);
    i0.ɵɵlistener("click", function HeaderComponent_div_4_Conditional_1_Conditional_8_span_3_Template_span_click_0_listener() {
      i0.ɵɵrestoreView(_r26);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.openNotificationSettings());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "UI-LIB.HEADER.NOTIFICATION"), " ");
  }
}
function HeaderComponent_div_4_Conditional_1_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HeaderComponent_div_4_Conditional_1_Conditional_8_span_0_Template, 4, 8, "span", 81)(1, HeaderComponent_div_4_Conditional_1_Conditional_8_span_1_Template, 4, 8, "span", 81)(2, HeaderComponent_div_4_Conditional_1_Conditional_8_span_2_Template, 4, 8, "span", 81)(3, HeaderComponent_div_4_Conditional_1_Conditional_8_span_3_Template, 3, 3, "span", 82);
    i0.ɵɵelement(4, "div", 60);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngIf", !ctx_r1.isAdmin);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isAdmin);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isAdmin);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isAdmin);
  }
}
function HeaderComponent_div_4_Conditional_1_geaui_icon_v2_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "geaui-icon-v2", 84);
  }
}
function HeaderComponent_div_4_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 71)(1, "span", 73);
    i0.ɵɵelement(2, "geaui-icon-v2", 74);
    i0.ɵɵelementStart(3, "span", 75);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(6, "div", 60);
    i0.ɵɵtemplate(7, HeaderComponent_div_4_Conditional_1_Conditional_7_Template, 2, 2)(8, HeaderComponent_div_4_Conditional_1_Conditional_8_Template, 5, 4);
    i0.ɵɵelementStart(9, "span", 76);
    i0.ɵɵlistener("click", function HeaderComponent_div_4_Conditional_1_Template_span_click_9_listener() {
      i0.ɵɵrestoreView(_r22);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.logout());
    });
    i0.ɵɵtemplate(10, HeaderComponent_div_4_Conditional_1_geaui_icon_v2_10_Template, 1, 0, "geaui-icon-v2", 77);
    i0.ɵɵelementStart(11, "span", 78);
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(11, _c5));
    i0.ɵɵproperty("file", ctx_r1.isAdmin || ctx_r1.headerNgxsService.currentUserContext === "TEMP_MEMBERSHIP" ? "24px_office" : "24px_profile");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 7, ctx_r1.headerNgxsService.userName || (ctx_r1.isAdmin ? "UI-LIB.HEADER.USER_MENU.GEA_ADMIN_LOGIN_FALLBACK" : "UI-LIB.HEADER.USER_MENU.CUSTOMER_LOGIN_FALLBACK")), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r1.headerNgxsService.currentUserContext !== "PORTAL_USER" ? 7 : 8);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.mobileView);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(13, 9, "UI-LIB.HEADER.LOGOUT"), "");
  }
}
function HeaderComponent_div_4_Conditional_2_geaui_button_v2_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "geaui-button-v2", 88);
    i0.ɵɵlistener("click", function HeaderComponent_div_4_Conditional_2_geaui_button_v2_1_Template_geaui_button_v2_click_0_listener() {
      i0.ɵɵrestoreView(_r27);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.loginService.login());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("flex", true);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(2, 2, "UI-LIB.HEADER.LOGIN"), " ");
  }
}
function HeaderComponent_div_4_Conditional_2_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 89);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "UI-LIB.HEADER.NO-ACCOUNT"));
  }
}
function HeaderComponent_div_4_Conditional_2_geaui_button_v2_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "geaui-button-v2", 90);
    i0.ɵɵlistener("click", function HeaderComponent_div_4_Conditional_2_geaui_button_v2_3_Template_geaui_button_v2_click_0_listener() {
      i0.ɵɵrestoreView(_r28);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.goToDashboard());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(2, 1, "UI-LIB.HEADER.SIGNUP"), " ");
  }
}
function HeaderComponent_div_4_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 72);
    i0.ɵɵtemplate(1, HeaderComponent_div_4_Conditional_2_geaui_button_v2_1_Template, 3, 4, "geaui-button-v2", 85)(2, HeaderComponent_div_4_Conditional_2_span_2_Template, 3, 3, "span", 86)(3, HeaderComponent_div_4_Conditional_2_geaui_button_v2_3_Template, 3, 3, "geaui-button-v2", 87);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.disableLoginMobile);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.disableSignupMobile);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.disableSignupMobile);
  }
}
function HeaderComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 70);
    i0.ɵɵtemplate(1, HeaderComponent_div_4_Conditional_1_Template, 14, 12, "div", 71)(2, HeaderComponent_div_4_Conditional_2_Template, 4, 3, "div", 72);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.loginDisplay ? 1 : 2);
  }
}
function HeaderComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "geaui-banner");
    i0.ɵɵelementEnd();
  }
}
function HeaderComponent_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r29 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "geaui-system-status-dialog", 91);
    i0.ɵɵlistener("actionButtonClicked", function HeaderComponent_Conditional_10_Template_geaui_system_status_dialog_actionButtonClicked_0_listener() {
      i0.ɵɵrestoreView(_r29);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSystemMessageCloseClick());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("showDialog", !!ctx_r1.systemMessage)("title", ctx_r1.systemMessage.title)("message", ctx_r1.systemMessage.messageText)("severity", ctx_r1.systemMessage.type === "OUTAGE" ? "error" : "info");
  }
}
export class HeaderComponent {
  translate;
  breakpointObserver;
  router;
  resourcesService;
  ngZone;
  gaService;
  store;
  navigationService;
  actions$;
  headerUtilService;
  imageService;
  permissionService;
  loginService;
  monitoringService;
  inactivityService;
  dialogService;
  ref;
  msalAuthFacadeService;
  errorHandlerService;
  contactFormService;
  destroyed;
  systemMessageService;
  headerNgxsService;
  portalLink;
  redirectOnLogout = false;
  /**
   * @description set to true if page using the header is available without any authentication and login
   */
  noAuth = false;
  canOpenBurgerMenu = true;
  googleAnalyticsActivated = false;
  headerTitle = '';
  showBanner = true;
  showLangDropdown = false;
  shoppingCartUrl = '';
  shoppingCartBadge;
  disableSignupMobile = false;
  disableLoginMobile = false;
  /**
   * @description display the header without language dropdown and without the header dropdown options for User Administration, Orga Administration and Profile
   */
  set isAdmin(isAdmin) {
    this._isAdmin = isAdmin;
    this.inactivityService.setIsAdmin(isAdmin);
  }
  get isAdmin() {
    return this._isAdmin;
  }
  get languages$() {
    return this.resourcesService.getLanguageOptions().pipe(map(options => [...options].sort((a, b) => a.value.localeCompare(b.value))), map(options => [...options, {
      name: 'DV-DV',
      value: 'dv-DV'
    }]));
  }
  _showBurgerMenu = false;
  selectedLang = '';
  mobileView = false;
  arrowIcon = 'arrow-down';
  isIframe = false;
  loginDisplay = false;
  userPermissions = [];
  permissionKey = PermissionKey;
  lastUserAction;
  isLogoError = false;
  expirationTime;
  showNotifications = false;
  mobileSidebarOpen = false;
  showMobileProfile = false;
  inactivityDialogOpen = false;
  isErrorForm = false;
  errorCode = '';
  _isAdmin = false; // This is just to signify the admin app and Admin Header
  showContactForm$;
  currentShowDropdown = undefined;
  systemMessage;
  PORTAL_ADMINISTRATION_PATH = 'administration';
  PROFILE_PATH = 'profile';
  USER_PATH = 'user';
  ORGANISATION_PATH = 'organization';
  NOTIFICATION_SETTINGS_PATH = 'notification-settings';
  constructor(translate, breakpointObserver, router, resourcesService, ngZone, gaService, store, navigationService, actions$, headerUtilService, imageService, permissionService, loginService, monitoringService, inactivityService, dialogService, ref, msalAuthFacadeService, errorHandlerService, contactFormService, destroyed, systemMessageService, headerNgxsService, portalLink) {
    this.translate = translate;
    this.breakpointObserver = breakpointObserver;
    this.router = router;
    this.resourcesService = resourcesService;
    this.ngZone = ngZone;
    this.gaService = gaService;
    this.store = store;
    this.navigationService = navigationService;
    this.actions$ = actions$;
    this.headerUtilService = headerUtilService;
    this.imageService = imageService;
    this.permissionService = permissionService;
    this.loginService = loginService;
    this.monitoringService = monitoringService;
    this.inactivityService = inactivityService;
    this.dialogService = dialogService;
    this.ref = ref;
    this.msalAuthFacadeService = msalAuthFacadeService;
    this.errorHandlerService = errorHandlerService;
    this.contactFormService = contactFormService;
    this.destroyed = destroyed;
    this.systemMessageService = systemMessageService;
    this.headerNgxsService = headerNgxsService;
    this.portalLink = portalLink;
  }
  ngOnInit() {
    this.headerNgxsService.initializeNgxsData(this.canOpenBurgerMenu, this.googleAnalyticsActivated);
    this.navigationService.registerNavigationListener(this);
    this.isIframe = window !== window.parent && !window.opener;
    this.translate.onLangChange.subscribe(langChangeEvent => {
      this.selectedLang = langChangeEvent.lang;
    });
    this.headerNgxsService.expirationTime$.pipe(takeUntilDestroyed(this.destroyed)).subscribe(time => {
      this.expirationTime = time;
    });
    this.store.select(PermissionsState.userPermissions).subscribe(result => {
      if (result) {
        this.userPermissions = result;
      }
    });
    this.setUpActionListenerForMembershipChanges();
    this.headerUtilService.mobileSidebarOpen.pipe(takeUntilDestroyed(this.destroyed)).subscribe(value => {
      this.mobileSidebarOpen = value;
    });
    // Set callback Method for inactivity service
    this.inactivityService.setCallbackMethod(this.openInactivityDialog.bind(this));
    this.msalAuthFacadeService.initializeMsal(this.noAuth, this._isAdmin);
    this.msalAuthFacadeService.isLoggedIn$.subscribe(loggedIn => {
      this.loginDisplay = loggedIn;
    });
    this.selectedLang = this.translate.currentLang;
    this.breakpointObserver.observe(['(max-width: 767px)']).pipe(takeUntilDestroyed(this.destroyed)).subscribe(state => {
      this.mobileView = state.breakpoints['(max-width: 767px)'];
    });
    if (!this._isAdmin) {
      this.headerNgxsService.initializeNonAdminData();
    }
    this.errorHandlerService.reportErrorSubject.pipe(takeUntilDestroyed(this.destroyed)).subscribe(errorCode => {
      this.contactFormService.showContactForm();
      this.isErrorForm = true;
      this.errorCode = errorCode;
    });
    this.showContactForm$ = this.contactFormService.showContactForm$;
    this.systemMessageService.systemMessagesQue$.pipe(takeUntilDestroyed(this.destroyed)).subscribe(systemMessage => this.systemMessage = systemMessage);
    this.systemMessageService.newSystemMessagesArrived$.pipe(takeUntilDestroyed(this.destroyed)).subscribe(() => this.systemMessageService.processNextSystemMessage());
  }
  ngAfterViewInit() {
    this.monitoringService.appName = this.headerTitle;
    this.ngZone.runOutsideAngular(() => {
      merge(fromEvent(document, 'click'), fromEvent(document, 'touch')).pipe(throttleTime(500), skip(1), filter(() => this.loginDisplay), takeUntilDestroyed(this.destroyed)).subscribe({
        next: () => {
          // Only reset the timer if the dialog is not currently open, the site requires authentication and if it is not the admin app
          if (this.loginDisplay && !this.inactivityDialogOpen && !this._isAdmin) {
            this.inactivityService.resetTimer();
          }
        },
        // for debugging, since this is not an error that the user is informed about
        // eslint-disable-next-line no-console
        error: () => console.log('Error on user action fromEvent')
      });
    });
  }
  setUpActionListenerForMembershipChanges() {
    this.actions$.pipe(ofActionSuccessful(MembershipsChange)).subscribe(() => {
      this.permissionService.getPermissionsForStore();
    });
  }
  closeContactForm() {
    this.contactFormService.closeContactForm();
    this.isErrorForm = false;
  }
  onNavigation() {
    const nextStep = this.navigationService.getNextNavigation();
    if (nextStep) {
      switch (nextStep) {
        case NavigationComponent.PROFILE:
          {
            this.openProfile();
            break;
          }
        case NavigationComponent.USER_ADMIN:
          {
            this.openUserAdmin();
            break;
          }
        case NavigationComponent.ORGA_ADMIN:
          {
            this.openOrgaAdmin();
            break;
          }
        case NavigationComponent.NOTIFICATIONS:
          {
            this.openNotificationSettings();
            break;
          }
        default:
          {
            break;
          }
      }
    }
  }
  navigateToCart() {
    window.location.href = this.shoppingCartUrl;
  }
  openInactivityDialog() {
    this.inactivityDialogOpen = true;
    this.dialogService.open({
      yes: 'INACTIVITY.DIALOG.BUTTON',
      no: '',
      closable: false,
      hideButtons: false,
      hideDividingLines: true,
      hideHeader: true,
      showRejectButton: false,
      isSessionExpiredDialog: true,
      confirmCallback: () => {
        this.inactivityDialogOpen = false;
        this.inactivityService.startTimer();
      }
    }, InactivityCountdownComponent, 'inactivity-dialog');
    this.ref.detectChanges();
  }
  onLanguageChange(language) {
    this.translate.use(language);
  }
  logout() {
    if (this.googleAnalyticsActivated) {
      this.gaService.navigationPush('header', 'logout');
      this.gaService.loggedOutPush(this.router.url);
    }
    this.loginService.logout();
    this.loginDisplay = false;
  }
  goToDashboard() {
    if (this.googleAnalyticsActivated) {
      this.gaService.navigationPush('header', 'dashboard');
    }
    void this.router.navigate(['']);
  }
  toggleBurgerMenu() {
    if (this.loginDisplay) {
      this._showBurgerMenu = !this._showBurgerMenu;
    }
  }
  goToPortal() {
    if (this.googleAnalyticsActivated) {
      this.gaService.navigationPush('header', this.PROFILE_PATH);
    }
    window.location.href = this.portalLink;
  }
  openOrgaAdmin() {
    this.showMobileProfile = false;
    if (this.googleAnalyticsActivated) {
      this.gaService.navigationPush('header', 'orga-administration');
    }
    const target = (window.location.origin + window.location.pathname).startsWith(this.normalizeUrl(`${this.portalLink}/${this.PORTAL_ADMINISTRATION_PATH}`)) ? '_self' : '_blank';
    window.open(`${this.portalLink}/${this.PORTAL_ADMINISTRATION_PATH}/${this.ORGANISATION_PATH}`, target);
  }
  openNotificationSettings() {
    this.showMobileProfile = false;
    if (this.googleAnalyticsActivated) {
      this.gaService.navigationPush('header', this.NOTIFICATION_SETTINGS_PATH);
    }
    const target = (window.location.origin + window.location.pathname).startsWith(this.normalizeUrl(`${this.portalLink}/${this.PORTAL_ADMINISTRATION_PATH}`)) ? '_self' : '_blank';
    window.open(`${this.portalLink}/${this.PORTAL_ADMINISTRATION_PATH}/${this.NOTIFICATION_SETTINGS_PATH}`, target);
  }
  openProfile() {
    this.showMobileProfile = false;
    if (this.googleAnalyticsActivated) {
      this.gaService.navigationPush('header', this.PROFILE_PATH);
    }
    const target = (window.location.origin + window.location.pathname).startsWith(this.normalizeUrl(`${this.portalLink}/${this.PORTAL_ADMINISTRATION_PATH}`)) ? '_self' : '_blank';
    window.open(`${this.portalLink}/${this.PORTAL_ADMINISTRATION_PATH}/${this.PROFILE_PATH}`, target);
  }
  openUserAdmin() {
    this.showMobileProfile = false;
    if (this.googleAnalyticsActivated) {
      this.gaService.navigationPush('header', 'user-administration');
    }
    const target = (window.location.origin + window.location.pathname).startsWith(this.normalizeUrl(`${this.portalLink}/${this.PORTAL_ADMINISTRATION_PATH}`)) ? '_self' : '_blank';
    window.open(`${this.portalLink}/${this.PORTAL_ADMINISTRATION_PATH}/${this.USER_PATH}`, target);
  }
  toggleMobileSidebar() {
    if (this.loginDisplay) {
      this.showMobileProfile = false;
      this.headerUtilService.mobileSidebarOpen.next(!this.mobileSidebarOpen);
    }
  }
  toggleMenu(event) {
    event.stopPropagation();
    this.currentShowDropdown = this.currentShowDropdown === 'profile' ? undefined : 'profile';
  }
  toggleLanguageMenu(event) {
    event.stopPropagation();
    this.currentShowDropdown = this.currentShowDropdown === 'language' ? undefined : 'language';
  }
  closeAllMenus() {
    this.currentShowDropdown = undefined;
  }
  onLogoError() {
    this.isLogoError = true;
  }
  redirect(url) {
    location.href = url;
  }
  onSystemMessageCloseClick() {
    if (!this.systemMessage) return;
    this.systemMessageService.processNextSystemMessage();
  }
  normalizeUrl(url) {
    return url.replace(/([^:]\/)\/+/g, '$1');
  }
  static ɵfac = function HeaderComponent_Factory(t) {
    return new (t || HeaderComponent)(i0.ɵɵdirectiveInject(i1.TranslateService), i0.ɵɵdirectiveInject(i2.BreakpointObserver), i0.ɵɵdirectiveInject(i3.Router), i0.ɵɵdirectiveInject(i4.ResourcesService), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i5.GoogleAnalyticsService), i0.ɵɵdirectiveInject(i6.Store), i0.ɵɵdirectiveInject(i4.NavigationService), i0.ɵɵdirectiveInject(i6.Actions), i0.ɵɵdirectiveInject(i4.HeaderUtilService), i0.ɵɵdirectiveInject(i4.ImageService), i0.ɵɵdirectiveInject(i4.PermissionService), i0.ɵɵdirectiveInject(i7.LoginService), i0.ɵɵdirectiveInject(i4.MonitoringService), i0.ɵɵdirectiveInject(i8.InactivityService), i0.ɵɵdirectiveInject(i9.ComplexDialogV2Service), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i10.MsalAuthFacadeService), i0.ɵɵdirectiveInject(i9.ErrorHandlerV2Service), i0.ɵɵdirectiveInject(i11.ContactFormService), i0.ɵɵdirectiveInject(i0.DestroyRef), i0.ɵɵdirectiveInject(i12.SystemMessageService), i0.ɵɵdirectiveInject(i13.HeaderNgxsService), i0.ɵɵdirectiveInject('portalLink'));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: HeaderComponent,
    selectors: [["geaui-header"]],
    hostBindings: function HeaderComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("click", function HeaderComponent_click_HostBindingHandler($event) {
          return ctx.closeAllMenus($event);
        }, false, i0.ɵɵresolveDocument);
      }
    },
    inputs: {
      redirectOnLogout: "redirectOnLogout",
      noAuth: "noAuth",
      canOpenBurgerMenu: "canOpenBurgerMenu",
      googleAnalyticsActivated: "googleAnalyticsActivated",
      headerTitle: "headerTitle",
      showBanner: "showBanner",
      showLangDropdown: "showLangDropdown",
      shoppingCartUrl: "shoppingCartUrl",
      shoppingCartBadge: "shoppingCartBadge",
      disableSignupMobile: "disableSignupMobile",
      disableLoginMobile: "disableLoginMobile",
      isAdmin: "isAdmin"
    },
    decls: 14,
    vars: 12,
    consts: [["class", "header-container", "data-cy", "header", 3, "ngClass", 4, "ngIf"], ["geauiOutSideClick", "", 1, "burger-menu-container"], [3, "closed", 4, "ngIf"], ["class", "mobile-profile", 4, "ngIf"], [4, "ngIf"], [3, "key"], [3, "showDialog", "title", "message", "severity"], [1, "contact-form-side-modal"], [3, "closeContactFormSideModal", "show", "selectedCategory", "description"], ["data-cy", "header", 1, "header-container", 3, "ngClass"], [1, "header-toolbar-container"], [1, "menu-container"], ["file", "24px_tictactoe", "color", "white", "colorProp", "fill", 3, "ngClass", "click", 4, "ngIf"], ["class", "mobile-sidebar-icon", "color", "white", "colorProp", "both", 3, "file", "click", 4, "ngIf"], ["class", "logo", 3, "src", "alt", "error", "click", 4, "ngIf"], ["class", "logo-container", 4, "ngIf"], ["class", "default-logo-letter", 4, "ngIf"], [1, "environment-container"], [3, "isMobile"], ["class", "title-container", 4, "ngIf"], ["data-cy", "settings", 1, "settings-container"], [1, "logged-in-settings"], ["data-cy", "shopping-cart", 1, "shopping-cart"], ["class", "user-button", 3, "click", 4, "ngIf"], ["class", "header-menu", 3, "style", 4, "ngIf"], ["data-cy", "notifications-count", 3, "clicked", 4, "ngIf"], ["class", "user-button", 3, "ngClass", "click", 4, "ngIf"], ["class", "header-menu", 4, "ngIf"], ["class", "user-menu-icon", "color", "white", 3, "file", "click", 4, "ngIf"], ["file", "24px_tictactoe", "color", "white", "colorProp", "fill", 3, "click", "ngClass"], ["color", "white", "colorProp", "both", 1, "mobile-sidebar-icon", 3, "click", "file"], [1, "logo", 3, "error", "click", "src", "alt"], [1, "logo-container"], [1, "mobile-logo", 3, "error", "click", "src", "alt"], [1, "default-logo-letter"], [1, "title-container"], ["data-cy", "app-title"], ["data-cy", "shopping-cart", 1, "shopping-cart", 3, "click"], ["file", "24px_cart", "color", "white"], ["data-cy", "badge", 1, "badge"], [1, "user-button", 3, "click"], [1, "gea-font-body-16", "gea-font-white"], ["color", "white", 3, "file"], [1, "header-menu"], ["type", "secondary", "fontWeight", "normal", 1, "user-menu-item", "gea-font-body-16"], ["class", "user-menu-item gea-font-body-16", "type", "secondary", "fontWeight", "normal", 3, "click", 4, "ngIf"], ["type", "secondary", "fontWeight", "normal", 1, "user-menu-item", "gea-font-body-16", 3, "click"], ["data-cy", "notifications-count", 3, "clicked"], [1, "user-button", 3, "click", "ngClass"], [3, "color", "file"], [1, "gea-font-body-16", "masked-by-clarity", 3, "ngClass"], [3, "file", "color"], ["class", "user-menu-item login-item gea-font-body-16", "type", "secondary", "fontWeight", "normal", 3, "click", 4, "ngIf"], ["class", "user-menu-divider", 4, "ngIf"], ["class", "user-menu-item gea-font-body-16", "type", "secondary", "fontWeight", "normal", 3, "disabled", 4, "ngIf"], ["type", "secondary", "fontWeight", "normal", 1, "user-menu-item", "gea-font-body-16", 3, "disabled"], ["class", "user-menu-item gea-font-body-16", "type", "secondary", "fontWeight", "normal", 3, "disabled", "click", 4, "ngIf"], ["type", "secondary", "fontWeight", "normal", 1, "user-menu-item", "gea-font-body-16", 3, "click", "disabled"], ["type", "secondary", "fontWeight", "normal", 1, "user-menu-item", "login-item", "gea-font-body-16", 3, "click"], ["file", "16px_log-in", "color", "black", 1, "login-icon"], [1, "user-menu-divider"], ["aria-label", "Logout", "file", "16px_logout", "color", "black", 1, "login-icon"], ["color", "white", 1, "user-menu-icon", 3, "click", "file"], ["geauiOutSideClick", "", 1, "burger-menu-container", 3, "outSideClick"], [1, "burger-menu-app-count"], [1, "available-apps-container"], ["target", "_self", 1, "app-container", 3, "href"], [1, "app-icon", 3, "src", "alt"], ["lang", "de-DE", "geauiTooltipOnEllipsisV2", "", 1, "app-description", 3, "pTooltip"], [3, "closed"], [1, "mobile-profile"], [1, "mobile-menu-items"], [1, "mobile-signup-container"], [1, "mobile-user-menu-item", "logout"], ["color", "black", 1, "logout-icon", 3, "file"], [1, "gea-font-body-16", "masked-by-clarity"], [1, "mobile-user-menu-item", "logout", 3, "click"], ["class", "logout-icon", "file", "16px_logout", "color", "black", 4, "ngIf"], ["id", "mobileLogoutText"], ["class", "mobile-user-menu-item", "type", "secondary", "fontWeight", "normal", 3, "disabled", 4, "ngIf"], ["type", "secondary", "fontWeight", "normal", 1, "mobile-user-menu-item", 3, "disabled"], ["class", "mobile-user-menu-item", 3, "disabled", "click", 4, "ngIf"], ["class", "mobile-user-menu-item", 3, "click", 4, "ngIf"], [1, "mobile-user-menu-item", 3, "click"], ["file", "16px_logout", "color", "black", 1, "logout-icon"], ["class", "mobile-login-button", 3, "flex", "click", 4, "ngIf"], ["class", "singup-question", 4, "ngIf"], ["class", "mobile-signup-button", "type", "tertiary", 3, "click", 4, "ngIf"], [1, "mobile-login-button", 3, "click", "flex"], [1, "singup-question"], ["type", "tertiary", 1, "mobile-signup-button", 3, "click"], [3, "actionButtonClicked", "showDialog", "title", "message", "severity"]],
    template: function HeaderComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, HeaderComponent_div_0_Template, 20, 17, "div", 0)(1, HeaderComponent_Conditional_1_Template, 6, 1, "div", 1);
        i0.ɵɵelement(2, "geaui-snackbar");
        i0.ɵɵtemplate(3, HeaderComponent_geaui_notifications_sidebar_v2_3_Template, 1, 0, "geaui-notifications-sidebar-v2", 2)(4, HeaderComponent_div_4_Template, 3, 1, "div", 3)(5, HeaderComponent_div_5_Template, 2, 0, "div", 4);
        i0.ɵɵelement(6, "geaui-snackbar")(7, "geaui-complex-dialog-v2")(8, "geaui-complex-dialog-v2", 5)(9, "geaui-dialog-v2");
        i0.ɵɵtemplate(10, HeaderComponent_Conditional_10_Template, 1, 4, "geaui-system-status-dialog", 6);
        i0.ɵɵelementStart(11, "div", 7)(12, "geaui-contact-form-side-modal", 8);
        i0.ɵɵpipe(13, "async");
        i0.ɵɵlistener("closeContactFormSideModal", function HeaderComponent_Template_geaui_contact_form_side_modal_closeContactFormSideModal_12_listener() {
          return ctx.closeContactForm();
        });
        i0.ɵɵelementEnd()();
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.noAuth || ctx.loginDisplay);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx._showBurgerMenu ? 1 : -1);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.loginDisplay && ctx.showNotifications);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.mobileView && ctx.showMobileProfile);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.showBanner);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("key", "inactivity-dialog");
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.systemMessage ? 10 : -1);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("show", i0.ɵɵpipeBind1(13, 10, ctx.showContactForm$))("selectedCategory", ctx.isErrorForm ? "Report error" : "")("description", ctx.isErrorForm ? ctx.errorCode : "");
      }
    },
    dependencies: [i14.NgClass, i14.NgIf, i15.IconComponent, i16.Tooltip, i17.ButtonV2Component, i18.NotificationsCountV2Component, i19.NotificationsSidebarV2Component, i20.TooltipOnEllipsisV2Directive, i21.OutSideClickDirective, i22.BannerComponent, i23.DialogV2Component, i24.SnackbarComponent, i25.LinkV2Component, i26.ContactFormSideModalComponent, i27.ComplexDialogV2Component, i28.SystemStatusDialogComponent, i29.EnvironmentTagComponent, i14.AsyncPipe, i1.TranslatePipe, i30.CheckIfPermissionMissing],
    styles: [".ortus-light-theme[_ngcontent-%COMP%]   [_ngcontent-%COMP%]:root, .ortus-light-theme[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]{--geaui-primary: #0303B8;--geaui-secondary: #000F41;--geaui-tertiary: #1AFF80;--geaui-button-default: #0303B8;--geaui-primary-hover: #4F4FCD;--geaui-primary-pressed: #020281;--geaui-secondary-hover: #E6E6F8;--geaui-secondary-pressed: #CDCDF1;--geaui-focused-outline: #000F41;--geaui-focussed: #0303B8;--geaui-vibrant-blue: #0303B8;--geaui-vibrant-blue-30: #4F4FCD;--geaui-vibrant-blue-130: #020281;--geaui-vibrant-blue-180: #CDCDF1;--geaui-vibrant-blue-190: #E6E6F8;--geaui-night-blue: #000F41;--geaui-active-green: #1AFF80;--geaui-pure-black: #000000;--geaui-primary-black: #141414;--geaui-secondary-black: #505050;--geaui-grey-01: #8C8C8C;--geaui-grey-02: #C8C8C8;--geaui-grey-03: #DCDCDC;--geaui-grey-04: #E6E6E6;--geaui-grey-05: #F0F0F0;--geaui-grey-06: #F5F5F5;--geaui-pure-white: #FFFFFF;--geaui-energetic-pink: #FF80FF;--geaui-active-blue: #1F9DFF;--geaui-tertiary-green-60: #15BD5E;--geaui-tertiary-yellow-60: #FFDD2D;--geaui-dark-orange: #692C01;--geaui-radiant-orange-70: #FF740F;--geaui-tertiary-red-60: #FC4B53;--geaui-active-blue-50: #D5EDFF;--geaui-night-blue-120: #00081F;--geaui-energetic-pink-130: #BB23E0;--geaui-active-blue-120: #145DE2;--geaui-tertiary-green-80: #107C3C;--geaui-radiant-orange-110: #AF7927;--geaui-radiant-orange: #AF4A01;--geaui-tertiary-red-80: #A61920;--geaui-energetic-pink-60: #FFD0FF;--geaui-energetic-pink-140: #701586;--geaui-active-blue-60: #BFE3FF;--geaui-vibrant-blue-120: #08257F;--geaui-active-green-60: #DEFFEC;--geaui-tertiary-green-110: #0B5E2E;--geaui-tertiary-yellow-30: #FFF2B2;--geaui-tertiary-yellow-110: #393204;--geaui-radiant-orange-30: #FED3B3;--geaui-radiant-orange-120: #393204;--geaui-tertiary-red-30: #FFC8CB;--geaui-tertiary-red-110: #340111;--geaui-night-blue-130: #001664;--geaui-vibrant-blue-140: #391EC7;--geaui-vibrant-blue-110: #020A7D;--geaui-vibrant-blue-90: #0B2ECC;--geaui-active-blue-130: #0E3ED4;--geaui-active-blue-110: #197AEF;--geaui-active-blue-95: #42ADFF;--geaui-active-blue-90: #48AFFF;--geaui-active-blue-85: #66BCFF;--geaui-active-blue-80: #6BBEFF;--geaui-active-blue-75: #8CCDFF;--geaui-active-blue-70: #94D0FF;--geaui-active-blue-65: #B0DDFF;--geaui-grey-07: #282828;--geaui-grey-08: #3C3C3C;--geaui-grey-09: #646464;--geaui-grey-10: #787878;--geaui-grey-11: #A0A0A0;--geaui-grey-12: #B4B4B4;--geaui-grey-13: #FAFBFC;--geaui-tertiary-red: #57021D;--geaui-tertiary-red-90: #750E13;--geaui-tertiary-red-70: #DB1E28;--geaui-tertiary-red-50: #FF767C;--geaui-tertiary-red-40: #FFA4A9;--geaui-tertiary-green: #0A3D1B;--geaui-tertiary-green-90: #0D5C2B;--geaui-tertiary-green-70: #129C4D;--geaui-tertiary-green-50: #18DD6E;--geaui-tertiary-green-40: #53F99B;--geaui-tertiary-yellow: #5F5407;--geaui-tertiary-yellow-90: #917D05;--geaui-tertiary-yellow-80: #C5A703;--geaui-tertiary-yellow-70: #F2CB00;--geaui-tertiary-yellow-50: #FFE45B;--geaui-tertiary-yellow-40: #FFEA7F;--geaui-radiant-orange-90: #D65A00;--geaui-radiant-orange-80: #F36600;--geaui-radiant-orange-60: #FF8832;--geaui-radiant-orange-50: #FBA05E;--geaui-radiant-orange-40: #FEB580;--geaui-radiant-orange-20: #FAB301;--geaui-energetic-pink-120: #E842E8;--geaui-energetic-pink-110: #FF57FF;--geaui-energetic-pink-90: #FF8DFF;--geaui-energetic-pink-80: #FFA3FF;--geaui-energetic-pink-70: #FFB0FF;--geaui-active-green-90: #4AFF9B;--geaui-active-green-80: #7DFFB7;--geaui-active-green-70: #C8FFE0;--geaui-gradient-activegreen: linear-gradient(180deg, #001664 8.33%, #1AFF80 100%);--geaui-gradient-dailypink: linear-gradient(225.69deg, #FF80FF 0%, #FF80FF 15.63%, #391EC7 68.23%, #0303B8 100%);--geaui-night-blue-100: #000C34;--geaui-pure-white-brightness-30: rgba(255, 255, 255, .3);--geaui-gradient-energetic-pink: linear-gradient(153deg, #C239E3 16.67%, #EBBDF6 100%);--geaui-gradient-active-blue: linear-gradient(153deg, #3087F1 16.67%, #BAD7FA 100%);--geaui-gradient-green: linear-gradient(153deg, #1A7573 16.67%, #E6F0EF 100%);--geaui-gradient-vibrant-blue: linear-gradient(153deg, #0303B8 16.67%, #B3B3EA 100%);--geaui-gradient-midnight-blue: linear-gradient(155deg, #1A2754 15.99%, #B3B7C6 99.04%);--geaui-gradient-pink-blue: linear-gradient(#FF80FF, #391EC7, #0303B8);--geaui-background-vibrant-blue: #9A9AE3;--geaui-background-green: #80B3B1;--geaui-background-pink: #E4A7F3;--geaui-background-grey: #999FB3;--geaui-background-active-blue: #A3CAF9}.header-container[_ngcontent-%COMP%]{width:100%}.flex-1[_ngcontent-%COMP%]{flex:1;display:flex}.contact-form-side-modal[_ngcontent-%COMP%]{position:fixed;top:60px;right:0;width:fit-content;z-index:10;height:calc(100% - 60px)}.header-toolbar-container[_ngcontent-%COMP%]{border-radius:0;background-color:var(--geaui-night-blue);padding:0 8px;height:60px;display:flex;justify-content:space-between;font-size:14px;font-family:GEA Inter SemiBold,Arial,sans-serif;position:sticky;width:100%;z-index:30;top:0}.header-toolbar-container[_ngcontent-%COMP%]   .menu-container[_ngcontent-%COMP%]{display:flex;width:200px;justify-content:flex-start;align-items:center;padding-left:10px}.header-toolbar-container[_ngcontent-%COMP%]   .menu-container[_ngcontent-%COMP%]   .menu-icon[_ngcontent-%COMP%]{width:40px;height:40px;font-size:40px}.header-toolbar-container[_ngcontent-%COMP%]   .menu-container[_ngcontent-%COMP%]   .burger-icon-hover[_ngcontent-%COMP%]:hover{cursor:pointer}.header-toolbar-container[_ngcontent-%COMP%]   .menu-container[_ngcontent-%COMP%]   .logo[_ngcontent-%COMP%]{height:20px;margin-left:22px;cursor:pointer}.header-toolbar-container[_ngcontent-%COMP%]   .menu-container[_ngcontent-%COMP%]   .default-logo-letter[_ngcontent-%COMP%]{font-family:GEA Sans,Arial,sans-serif;font-weight:700;color:var(--geaui-white);font-size:40px;margin-left:47.5px}.header-toolbar-container[_ngcontent-%COMP%]   .menu-container[_ngcontent-%COMP%]   .drawer[_ngcontent-%COMP%]{transform:scale(.6)}.header-toolbar-container[_ngcontent-%COMP%]   .environment-container[_ngcontent-%COMP%]{display:flex;align-items:center}.header-toolbar-container[_ngcontent-%COMP%]   .title-container[_ngcontent-%COMP%]{display:flex;flex:1;justify-content:center;align-items:center;color:var(--geaui-white);font-size:16px;font-weight:600}.header-toolbar-container[_ngcontent-%COMP%]   .settings-container[_ngcontent-%COMP%]{display:flex;justify-content:flex-end;align-items:center;justify-items:flex-end;color:var(--geaui-white);height:100%}.header-toolbar-container[_ngcontent-%COMP%]   .settings-container[_ngcontent-%COMP%]   .language-select[_ngcontent-%COMP%]{margin-right:10px;background-color:var(--geaui-night-blue);width:auto}.header-toolbar-container[_ngcontent-%COMP%]   .settings-container[_ngcontent-%COMP%]   .language-select[_ngcontent-%COMP%]     .mat-select-value{margin-right:5px}.header-toolbar-container[_ngcontent-%COMP%]   .settings-container[_ngcontent-%COMP%]   .language-select[_ngcontent-%COMP%]     .mat-select-value .mat-select-arrow{color:var(--geaui-white)}.header-toolbar-container[_ngcontent-%COMP%]   .settings-container[_ngcontent-%COMP%]   .login[_ngcontent-%COMP%]{background-color:var(--geaui-night-blue);color:var(--geaui-white)}.header-toolbar-container[_ngcontent-%COMP%]   .settings-container[_ngcontent-%COMP%]   #signup[_ngcontent-%COMP%]{margin-right:-5px}.header-toolbar-container[_ngcontent-%COMP%]   .settings-container[_ngcontent-%COMP%]   .loginText[_ngcontent-%COMP%]{margin-left:7px}.header-toolbar-container[_ngcontent-%COMP%]   .settings-container[_ngcontent-%COMP%]   #userMenu[_ngcontent-%COMP%]{margin-left:28px;width:120px!important}.header-toolbar-container[_ngcontent-%COMP%]   .settings-container[_ngcontent-%COMP%]   .user-button[_ngcontent-%COMP%]{color:var(--geaui-white);background-color:var(--geaui-night-blue);margin:0 15px;display:flex;align-items:center;gap:10px;cursor:pointer}.header-toolbar-container[_ngcontent-%COMP%]   .settings-container[_ngcontent-%COMP%]   .user-button.admin-background[_ngcontent-%COMP%]{padding:8px;border-radius:4px;background-color:var(--geaui-tertiary)}.header-toolbar-container[_ngcontent-%COMP%]   .settings-container[_ngcontent-%COMP%]   .bell[_ngcontent-%COMP%]{margin-left:36.44px;margin-right:13px;transform:scale(.95)}.header-toolbar-container[_ngcontent-%COMP%]   .settings-container[_ngcontent-%COMP%]   #userIcon[_ngcontent-%COMP%]{margin-right:12px}.header-toolbar-container[_ngcontent-%COMP%]   .settings-container[_ngcontent-%COMP%]     .arrow svg path{stroke:var(--geaui-white)}.header-toolbar-container[_ngcontent-%COMP%]   .logo-container[_ngcontent-%COMP%]{display:flex;justify-content:center;height:20px;margin-left:16px}.header-toolbar-container[_ngcontent-%COMP%]   .logo-container[_ngcontent-%COMP%]   .mobile-logo[_ngcontent-%COMP%]{cursor:pointer;height:20px}.header-toolbar-container[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{cursor:pointer}.loginIcon[_ngcontent-%COMP%]{transform:scale(.8)}#logoutText[_ngcontent-%COMP%]{margin-right:10px;font-family:GEA Inter Medium,Arial,sans-serif}.user-menu-item[_ngcontent-%COMP%]{display:flex;align-items:center;padding:8px 15px;color:var(--geaui-primary-black)}.user-menu-item[_ngcontent-%COMP%]   .user-menu-item-warning-icon[_ngcontent-%COMP%]{margin-right:6px;width:16px;height:16px}.user-menu-item[_ngcontent-%COMP%]:hover{background-color:#4f4fcd66;border-radius:4px;cursor:pointer}.user-menu-item.text[_ngcontent-%COMP%]{cursor:default}.user-menu-item.login-item[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:center}.user-menu-item.login-item[_ngcontent-%COMP%]   .login-icon[_ngcontent-%COMP%]{margin-right:8px}.logged-in-settings[_ngcontent-%COMP%]{display:flex;align-items:center;height:100%}.logged-in-settings[_ngcontent-%COMP%]   .shopping-cart[_ngcontent-%COMP%]{margin-right:16px;display:flex;justify-content:center;align-items:center;cursor:pointer;background-color:var(--geaui-primary);height:100%;padding-right:12px;padding-left:12px}.logged-in-settings[_ngcontent-%COMP%]   .shopping-cart[_ngcontent-%COMP%]   .badge[_ngcontent-%COMP%]{background-color:#ff80ff;border-radius:4px;height:19px;line-height:16px;min-width:16px;padding:2px 4px;margin-left:10px;text-align:center;color:var(--geaui-primary-black);font-size:12px}.logged-in-settings[_ngcontent-%COMP%]   .shopping-cart[_ngcontent-%COMP%]:hover{background-color:var(--geaui-primary-hover)}.logged-in-settings[_ngcontent-%COMP%]   .shopping-cart[_ngcontent-%COMP%]:active{background-color:var(--geaui-primary-pressed)}.user-menu-item[_ngcontent-%COMP%]:disabled{background-color:var(--geaui-grey-06);color:var(--geaui-grey-01);pointer-events:unset}.user-menu-divider[_ngcontent-%COMP%]{border-top:2px solid var(--geaui-grey-03);width:85%;margin-top:12px;margin-bottom:12px;margin-left:15px}.header-menu[_ngcontent-%COMP%]{background-color:var(--geaui-grey-06);min-width:220px;overflow:scroll;padding:10px 15px;margin-left:-15px;display:flex;flex-direction:column;position:absolute;gap:8px;top:60px;right:8px;box-shadow:0 0 14px #0000001a}.header-menu[_ngcontent-%COMP%]   .user-menu-icon[_ngcontent-%COMP%]{padding:15px 8px;margin:10px}.settings-container[_ngcontent-%COMP%]   .gea-header-notification-icon[_ngcontent-%COMP%]{position:relative;top:8px}.menu-item-text-wrapper[_ngcontent-%COMP%]{display:inline-block;vertical-align:middle;font-size:16px;font-family:GEA Inter Medium,Arial,sans-serif}.mobile-sidebar-icon[_ngcontent-%COMP%]{margin-left:12px;cursor:pointer}geaui-notifications-count[_ngcontent-%COMP%]{display:flex}.burger-menu-container[_ngcontent-%COMP%]{position:absolute;left:10px;z-index:1000;width:410px;background-color:#f5f5f5;box-shadow:0 8px 16px #14141414}.burger-menu-container[_ngcontent-%COMP%]   .burger-menu-app-count[_ngcontent-%COMP%]{color:var(--geaui-black);font-size:20px;line-height:130%;margin:24px 24px 0}.burger-menu-container[_ngcontent-%COMP%]   .available-apps-container[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;padding:32px 24px 24px;gap:16px}.burger-menu-container[_ngcontent-%COMP%]   .available-apps-container[_ngcontent-%COMP%]   .app-container[_ngcontent-%COMP%]{display:flex;justify-content:center;flex-direction:column;align-items:center;text-align:center;width:110px;color:var(--geaui-black);row-gap:8px;padding:8px;text-decoration:none}.burger-menu-container[_ngcontent-%COMP%]   .available-apps-container[_ngcontent-%COMP%]   .app-container[_ngcontent-%COMP%]:hover{background-color:#4f4fcd66;border-radius:10px;cursor:pointer}.burger-menu-container[_ngcontent-%COMP%]   .available-apps-container[_ngcontent-%COMP%]   .app-container[_ngcontent-%COMP%]   .app-icon[_ngcontent-%COMP%]{width:64px}.burger-menu-container[_ngcontent-%COMP%]   .available-apps-container[_ngcontent-%COMP%]   .app-container[_ngcontent-%COMP%]   .app-description[_ngcontent-%COMP%]{font-size:14px;height:60px;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:3;overflow:hidden;text-overflow:ellipsis;line-height:140%;width:100%;overflow-wrap:break-word;hyphens:none;-moz-hyphens:none}.mobile-container[_ngcontent-%COMP%]   .user-menu-icon[_ngcontent-%COMP%]{margin-right:12px;margin-left:24px;cursor:pointer}.mobile-container[_ngcontent-%COMP%]   .menu-container[_ngcontent-%COMP%]{width:unset}.mobile-profile[_ngcontent-%COMP%]{background-color:var(--geaui-grey-06);height:calc(100vh - 60px);position:absolute;width:100%;z-index:6}.mobile-user-name[_ngcontent-%COMP%]{font-size:20px;font-weight:500;line-height:130%;padding-top:26px;padding-bottom:16px;padding-left:24px;display:block}.mobile-menu-items[_ngcontent-%COMP%]{display:flex;flex-direction:column}.mobile-menu-items[_ngcontent-%COMP%]   .mobile-user-menu-item[_ngcontent-%COMP%]{cursor:pointer;font-size:14px;font-weight:500;line-height:130%;display:block;margin-top:16px;margin-bottom:16px;margin-left:24px}.mobile-menu-items[_ngcontent-%COMP%]   .mobile-user-menu-item.logout[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:center}.mobile-menu-items[_ngcontent-%COMP%]   .mobile-user-menu-item.logout[_ngcontent-%COMP%]   #mobileLogoutText[_ngcontent-%COMP%]{margin-left:8px}.mobile-signup-container[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:center}.mobile-signup-container[_ngcontent-%COMP%]   .mobile-login-button[_ngcontent-%COMP%]{width:100%;padding:40px 20px 0}.mobile-signup-container[_ngcontent-%COMP%]   .singup-question[_ngcontent-%COMP%]{margin-top:40px}.mobile-signup-container[_ngcontent-%COMP%]   .mobile-signup-button[_ngcontent-%COMP%]{padding-top:16px}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderComponent, [{
    type: Component,
    args: [{
      selector: 'geaui-header',
      template: "<div class=\"header-container\" *ngIf=\"noAuth || loginDisplay\" [ngClass]=\"{ 'mobile-container': mobileView }\" data-cy=\"header\">\n  <div class=\"header-toolbar-container\">\n    <div class=\"menu-container\">\n      <geaui-icon-v2\n        *ngIf=\"!mobileView\"\n        [ngClass]=\"{ 'burger-icon-hover': canOpenBurgerMenu }\"\n        (click)=\"canOpenBurgerMenu ? toggleBurgerMenu() : undefined\"\n        file=\"24px_tictactoe\"\n        color=\"white\"\n        colorProp=\"fill\"></geaui-icon-v2>\n      <geaui-icon-v2\n        class=\"mobile-sidebar-icon\"\n        *ngIf=\"mobileView\"\n        [file]=\"mobileSidebarOpen ? '24px_close' : '24px_burgermenu'\"\n        (click)=\"toggleMobileSidebar()\"\n        color=\"white\"\n        colorProp=\"both\"></geaui-icon-v2>\n      <img\n        class=\"logo\"\n        *ngIf=\"!mobileView && !isLogoError\"\n        [src]=\"imageService.getLogo()\"\n        [alt]=\"'GEA'\"\n        (error)=\"this.onLogoError()\"\n        (click)=\"goToPortal()\" />\n      <div class=\"logo-container\" *ngIf=\"mobileView && !isLogoError\">\n        <img\n          class=\"mobile-logo\"\n          [src]=\"imageService.getLogo()\"\n          [alt]=\"'GEA'\"\n          (error)=\"this.onLogoError()\"\n          (click)=\"goToPortal()\" />\n      </div>\n      <span class=\"default-logo-letter\" *ngIf=\"isLogoError\">GEA</span>\n    </div>\n    <div class=\"environment-container\">\n      <geaui-environment-tag [isMobile]=\"mobileView\"></geaui-environment-tag>\n    </div>\n    <div class=\"title-container\" *ngIf=\"!mobileView\">\n      <span data-cy=\"app-title\">{{ headerTitle }}</span>\n    </div>\n    <div class=\"settings-container\" data-cy=\"settings\">\n      <div class=\"logged-in-settings\">\n        @if (shoppingCartUrl.length) {\n          <div class=\"shopping-cart\" (click)=\"navigateToCart()\" data-cy=\"shopping-cart\">\n            <geaui-icon-v2 file=\"24px_cart\" color=\"white\"></geaui-icon-v2>\n            @if (shoppingCartBadge) {\n              <span class=\"badge\" data-cy=\"badge\">{{ shoppingCartBadge | translate }}</span>\n            }\n          </div>\n        }\n        <div class=\"user-button\" *ngIf=\"!mobileView && showLangDropdown\" (click)=\"toggleLanguageMenu($event)\">\n          <span class=\"gea-font-body-16 gea-font-white\">{{\n            'X.LANGUAGE.' + translate.currentLang.toUpperCase() | translate\n          }}</span>\n          <geaui-icon-v2\n            [file]=\"currentShowDropdown === 'language' ? '16px_chevron-up' : '16px_chevron-down'\"\n            color=\"white\"></geaui-icon-v2>\n        </div>\n        <div class=\"header-menu\" *ngIf=\"currentShowDropdown === 'language'\" [style]=\"{ height: '240px', right: '140px' }\">\n          @for (lang of languages$ | async; track lang.nameKey) {\n            <geaui-link-v2\n              class=\"user-menu-item gea-font-body-16\"\n              *ngIf=\"!noAuth || isAdmin\"\n              (click)=\"onLanguageChange(lang.value)\"\n              type=\"secondary\"\n              fontWeight=\"normal\">\n              {{ 'X.LANGUAGE.' + lang.name | translate }}\n            </geaui-link-v2>\n          }\n        </div>\n        <geaui-notifications-count-v2\n          *ngIf=\"!isAdmin && loginDisplay\"\n          (clicked)=\"this.showNotifications = !this.showNotifications\"\n          data-cy=\"notifications-count\"></geaui-notifications-count-v2>\n        <!-- Cleanup-Ticket: Refactor the user menu in it's own component   -->\n        <div\n          class=\"user-button\"\n          *ngIf=\"!mobileView\"\n          [ngClass]=\"{ 'admin-background': headerNgxsService.currentUserContext === 'TEMP_MEMBERSHIP' }\"\n          (click)=\"toggleMenu($event)\">\n          <geaui-icon-v2\n            [color]=\"headerNgxsService.currentUserContext === 'TEMP_MEMBERSHIP' ? 'black' : 'white'\"\n            [file]=\"\n              isAdmin || headerNgxsService.currentUserContext === 'TEMP_MEMBERSHIP' ? '24px_office' : '24px_profile'\n            \"></geaui-icon-v2>\n          <span\n            class=\"gea-font-body-16 masked-by-clarity\"\n            [ngClass]=\"{ 'gea-font-white': headerNgxsService.currentUserContext !== 'TEMP_MEMBERSHIP' }\">\n            {{\n              this.headerNgxsService.userName || (isAdmin ? 'UI-LIB.HEADER.USER_MENU.GEA_ADMIN_LOGIN_FALLBACK' : '') | translate\n            }}\n          </span>\n          <geaui-icon-v2\n            [file]=\"currentShowDropdown === 'profile' ? '16px_chevron-up' : '16px_chevron-down'\"\n            [color]=\"headerNgxsService.currentUserContext === 'TEMP_MEMBERSHIP' ? 'black' : 'white'\">\n          </geaui-icon-v2>\n        </div>\n        <div class=\"header-menu\" *ngIf=\"currentShowDropdown === 'profile'\">\n          @if (headerNgxsService.currentUserContext !== 'PORTAL_USER') {\n            <geaui-link-v2\n              class=\"user-menu-item gea-font-body-16\"\n              *ngIf=\"!isAdmin && loginDisplay\"\n              [disabled]=\"true\"\n              type=\"secondary\"\n              fontWeight=\"normal\">\n              {{ 'X.LABEL.ORGANISATION' | translate }}: {{ headerNgxsService.tempUserMembership.name }}\n            </geaui-link-v2>\n            <geaui-link-v2\n              class=\"user-menu-item gea-font-body-16\"\n              *ngIf=\"!isAdmin && loginDisplay\"\n              [disabled]=\"true\"\n              type=\"secondary\"\n              fontWeight=\"normal\">\n              {{ 'X.LABEL.ROLE' | translate }}\n              :\n              {{\n                (headerNgxsService.tempUserMembership.roles[0]\n                  ? 'X.ROLE.' + headerNgxsService.tempUserMembership.roles[0].toUpperCase()\n                  : ''\n                ) | translate\n              }}\n            </geaui-link-v2>\n          } @else {\n            <geaui-link-v2\n              class=\"user-menu-item gea-font-body-16\"\n              *ngIf=\"!isAdmin && loginDisplay\"\n              [disabled]=\"userPermissions | checkIfPermissionMissing: permissionKey.READ_OWN_PROFILE\"\n              (click)=\"openProfile()\"\n              type=\"secondary\"\n              fontWeight=\"normal\">\n              {{ 'UI-LIB.HEADER.PROFILE' | translate }}\n            </geaui-link-v2>\n            <geaui-link-v2\n              class=\"user-menu-item gea-font-body-16\"\n              *ngIf=\"!isAdmin && loginDisplay\"\n              [disabled]=\"userPermissions | checkIfPermissionMissing: permissionKey.READ_USER_LIST\"\n              (click)=\"openUserAdmin()\"\n              type=\"secondary\"\n              fontWeight=\"normal\">\n              {{ 'UI-LIB.HEADER.USER' | translate }}\n            </geaui-link-v2>\n            <geaui-link-v2\n              class=\"user-menu-item gea-font-body-16\"\n              *ngIf=\"!isAdmin && loginDisplay\"\n              [disabled]=\"userPermissions | checkIfPermissionMissing: permissionKey.READ_ORGANIZATION_LIST\"\n              (click)=\"openOrgaAdmin()\"\n              type=\"secondary\"\n              fontWeight=\"normal\">\n              {{ 'UI-LIB.HEADER.ORGA' | translate }}\n            </geaui-link-v2>\n            <geaui-link-v2\n              class=\"user-menu-item gea-font-body-16\"\n              *ngIf=\"!isAdmin && loginDisplay\"\n              [disabled]=\"userPermissions | checkIfPermissionMissing: permissionKey.NOTIFICATION_SETTINGS_ACCESS\"\n              (click)=\"openNotificationSettings()\"\n              type=\"secondary\"\n              fontWeight=\"normal\">\n              {{ 'UI-LIB.HEADER.NOTIFICATION' | translate }}\n            </geaui-link-v2>\n          }\n          <geaui-link-v2\n            class=\"user-menu-item login-item gea-font-body-16\"\n            *ngIf=\"!loginDisplay\"\n            (click)=\"loginService.login()\"\n            type=\"secondary\"\n            fontWeight=\"normal\">\n            <geaui-icon-v2 class=\"login-icon\" file=\"16px_log-in\" color=\"black\"></geaui-icon-v2>\n            {{ 'UI-LIB.HEADER.LOGIN' | translate }}\n          </geaui-link-v2>\n          <div class=\"user-menu-divider\" *ngIf=\"!isAdmin && loginDisplay\"></div>\n          <geaui-link-v2\n            class=\"user-menu-item login-item gea-font-body-16\"\n            *ngIf=\"loginDisplay\"\n            (click)=\"logout()\"\n            type=\"secondary\"\n            fontWeight=\"normal\">\n            <geaui-icon-v2 class=\"login-icon\" aria-label=\"Logout\" file=\"16px_logout\" color=\"black\"></geaui-icon-v2>\n            {{ 'UI-LIB.HEADER.LOGOUT' | translate }}\n          </geaui-link-v2>\n        </div>\n        <geaui-icon-v2\n          class=\"user-menu-icon\"\n          *ngIf=\"mobileView\"\n          [file]=\"\n            showMobileProfile\n              ? '24px_close'\n              : headerNgxsService.currentUserContext === 'PORTAL_USER' || !headerNgxsService.currentUserContext\n                ? '24px_profile'\n                : '24px_office'\n          \"\n          (click)=\"\n            loginDisplay || !disableLoginMobile || !disableSignupMobile ? (showMobileProfile = !showMobileProfile) : undefined\n          \"\n          color=\"white\"></geaui-icon-v2>\n      </div>\n    </div>\n  </div>\n</div>\n@if (_showBurgerMenu) {\n  <div class=\"burger-menu-container\" (outSideClick)=\"_showBurgerMenu = false\" geauiOutSideClick>\n    <div class=\"burger-menu-app-count\">{{ headerNgxsService.availableApps }}</div>\n    <div class=\"available-apps-container\">\n      @for (app of headerNgxsService.appList; track $index) {\n        <a class=\"app-container\" [href]=\"app.url\" target=\"_self\">\n          <img class=\"app-icon\" [src]=\"app.imagePath\" [alt]=\"app.appKey\" />\n          <!-- lang=\"de-De\" set for hyphens to work in chrome -->\n          <div\n            class=\"app-description\"\n            lang=\"de-DE\"\n            pTooltip=\"{{ 'APPS.' + app.appKey + '.WIDGETS.APP_LINK.NAME' | translate }}\"\n            geauiTooltipOnEllipsisV2>\n            {{ 'APPS.' + app.appKey + '.WIDGETS.APP_LINK.NAME' | translate }}\n          </div>\n        </a>\n      }\n    </div>\n  </div>\n}\n<geaui-snackbar></geaui-snackbar>\n<geaui-notifications-sidebar-v2 *ngIf=\"loginDisplay && showNotifications\" (closed)=\"showNotifications = false\">\n</geaui-notifications-sidebar-v2>\n<div class=\"mobile-profile\" *ngIf=\"mobileView && showMobileProfile\">\n  @if (loginDisplay) {\n    <div class=\"mobile-menu-items\">\n      <span class=\"mobile-user-menu-item logout\">\n        <geaui-icon-v2\n          class=\"logout-icon\"\n          [style]=\"{ 'margin-right': '4px' }\"\n          [file]=\"isAdmin || headerNgxsService.currentUserContext === 'TEMP_MEMBERSHIP' ? '24px_office' : '24px_profile'\"\n          color=\"black\">\n        </geaui-icon-v2>\n        <span class=\"gea-font-body-16 masked-by-clarity\">\n          {{\n            this.headerNgxsService.userName ||\n              (isAdmin ? 'UI-LIB.HEADER.USER_MENU.GEA_ADMIN_LOGIN_FALLBACK' : 'UI-LIB.HEADER.USER_MENU.CUSTOMER_LOGIN_FALLBACK')\n              | translate\n          }}\n        </span>\n      </span>\n      <div class=\"user-menu-divider\"></div>\n      @if (headerNgxsService.currentUserContext !== 'PORTAL_USER') {\n        <geaui-link-v2 class=\"mobile-user-menu-item\" *ngIf=\"!isAdmin\" [disabled]=\"true\" type=\"secondary\" fontWeight=\"normal\">\n          {{ 'X.LABEL.ORGANISATION' | translate }}: {{ headerNgxsService.tempUserMembership.name }}\n        </geaui-link-v2>\n        <geaui-link-v2 class=\"mobile-user-menu-item\" *ngIf=\"!isAdmin\" [disabled]=\"true\" type=\"secondary\" fontWeight=\"normal\">\n          {{ 'X.LABEL.ROLE' | translate }}:\n          {{\n            (headerNgxsService.tempUserMembership.roles[0]\n              ? 'X.ROLE.' + headerNgxsService.tempUserMembership.roles[0].toUpperCase()\n              : ''\n            ) | translate\n          }}\n        </geaui-link-v2>\n      } @else {\n        <span\n          class=\"mobile-user-menu-item\"\n          *ngIf=\"!isAdmin\"\n          [class.disabled]=\"userPermissions | checkIfPermissionMissing: permissionKey.READ_OWN_PROFILE\"\n          (click)=\"openProfile()\">\n          {{ 'UI-LIB.HEADER.PROFILE' | translate }}\n        </span>\n        <span\n          class=\"mobile-user-menu-item\"\n          *ngIf=\"!isAdmin\"\n          [class.disabled]=\"userPermissions | checkIfPermissionMissing: permissionKey.READ_USER_LIST\"\n          (click)=\"openUserAdmin()\">\n          {{ 'UI-LIB.HEADER.USER' | translate }} </span\n        ><span\n          class=\"mobile-user-menu-item\"\n          *ngIf=\"!isAdmin\"\n          [class.disabled]=\"userPermissions | checkIfPermissionMissing: permissionKey.READ_ORGANIZATION_LIST\"\n          (click)=\"openOrgaAdmin()\">\n          {{ 'UI-LIB.HEADER.ORGA' | translate }}\n        </span>\n        <span class=\"mobile-user-menu-item\" *ngIf=\"!isAdmin\" (click)=\"openNotificationSettings()\">\n          {{ 'UI-LIB.HEADER.NOTIFICATION' | translate }}\n        </span>\n        <div class=\"user-menu-divider\"></div>\n      }\n      <span class=\"mobile-user-menu-item logout\" (click)=\"logout()\">\n        <geaui-icon-v2 class=\"logout-icon\" *ngIf=\"mobileView\" file=\"16px_logout\" color=\"black\"></geaui-icon-v2>\n        <span id=\"mobileLogoutText\"> {{ 'UI-LIB.HEADER.LOGOUT' | translate }}</span>\n      </span>\n    </div>\n  } @else {\n    <div class=\"mobile-signup-container\">\n      <geaui-button-v2 class=\"mobile-login-button\" *ngIf=\"!disableLoginMobile\" [flex]=\"true\" (click)=\"loginService.login()\"\n        >{{ 'UI-LIB.HEADER.LOGIN' | translate }}\n      </geaui-button-v2>\n      <span class=\"singup-question\" *ngIf=\"!disableSignupMobile\">{{ 'UI-LIB.HEADER.NO-ACCOUNT' | translate }}</span>\n      <geaui-button-v2 class=\"mobile-signup-button\" *ngIf=\"!disableSignupMobile\" (click)=\"goToDashboard()\" type=\"tertiary\"\n        >{{ 'UI-LIB.HEADER.SIGNUP' | translate }}\n      </geaui-button-v2>\n    </div>\n  }\n</div>\n<div *ngIf=\"showBanner\">\n  <geaui-banner></geaui-banner>\n</div>\n\n<geaui-snackbar></geaui-snackbar>\n<geaui-complex-dialog-v2></geaui-complex-dialog-v2>\n<geaui-complex-dialog-v2 [key]=\"'inactivity-dialog'\"></geaui-complex-dialog-v2>\n<geaui-dialog-v2></geaui-dialog-v2>\n@if (systemMessage) {\n  <geaui-system-status-dialog\n    [showDialog]=\"!!systemMessage\"\n    [title]=\"systemMessage.title\"\n    [message]=\"systemMessage.messageText\"\n    [severity]=\"systemMessage.type === 'OUTAGE' ? 'error' : 'info'\"\n    (actionButtonClicked)=\"onSystemMessageCloseClick()\"></geaui-system-status-dialog>\n}\n<div class=\"contact-form-side-modal\">\n  <geaui-contact-form-side-modal\n    [show]=\"showContactForm$ | async\"\n    [selectedCategory]=\"isErrorForm ? 'Report error' : ''\"\n    [description]=\"isErrorForm ? errorCode : ''\"\n    (closeContactFormSideModal)=\"closeContactForm()\">\n  </geaui-contact-form-side-modal>\n</div>\n",
      styles: [".ortus-light-theme :root,.ortus-light-theme *{--geaui-primary: #0303B8;--geaui-secondary: #000F41;--geaui-tertiary: #1AFF80;--geaui-button-default: #0303B8;--geaui-primary-hover: #4F4FCD;--geaui-primary-pressed: #020281;--geaui-secondary-hover: #E6E6F8;--geaui-secondary-pressed: #CDCDF1;--geaui-focused-outline: #000F41;--geaui-focussed: #0303B8;--geaui-vibrant-blue: #0303B8;--geaui-vibrant-blue-30: #4F4FCD;--geaui-vibrant-blue-130: #020281;--geaui-vibrant-blue-180: #CDCDF1;--geaui-vibrant-blue-190: #E6E6F8;--geaui-night-blue: #000F41;--geaui-active-green: #1AFF80;--geaui-pure-black: #000000;--geaui-primary-black: #141414;--geaui-secondary-black: #505050;--geaui-grey-01: #8C8C8C;--geaui-grey-02: #C8C8C8;--geaui-grey-03: #DCDCDC;--geaui-grey-04: #E6E6E6;--geaui-grey-05: #F0F0F0;--geaui-grey-06: #F5F5F5;--geaui-pure-white: #FFFFFF;--geaui-energetic-pink: #FF80FF;--geaui-active-blue: #1F9DFF;--geaui-tertiary-green-60: #15BD5E;--geaui-tertiary-yellow-60: #FFDD2D;--geaui-dark-orange: #692C01;--geaui-radiant-orange-70: #FF740F;--geaui-tertiary-red-60: #FC4B53;--geaui-active-blue-50: #D5EDFF;--geaui-night-blue-120: #00081F;--geaui-energetic-pink-130: #BB23E0;--geaui-active-blue-120: #145DE2;--geaui-tertiary-green-80: #107C3C;--geaui-radiant-orange-110: #AF7927;--geaui-radiant-orange: #AF4A01;--geaui-tertiary-red-80: #A61920;--geaui-energetic-pink-60: #FFD0FF;--geaui-energetic-pink-140: #701586;--geaui-active-blue-60: #BFE3FF;--geaui-vibrant-blue-120: #08257F;--geaui-active-green-60: #DEFFEC;--geaui-tertiary-green-110: #0B5E2E;--geaui-tertiary-yellow-30: #FFF2B2;--geaui-tertiary-yellow-110: #393204;--geaui-radiant-orange-30: #FED3B3;--geaui-radiant-orange-120: #393204;--geaui-tertiary-red-30: #FFC8CB;--geaui-tertiary-red-110: #340111;--geaui-night-blue-130: #001664;--geaui-vibrant-blue-140: #391EC7;--geaui-vibrant-blue-110: #020A7D;--geaui-vibrant-blue-90: #0B2ECC;--geaui-active-blue-130: #0E3ED4;--geaui-active-blue-110: #197AEF;--geaui-active-blue-95: #42ADFF;--geaui-active-blue-90: #48AFFF;--geaui-active-blue-85: #66BCFF;--geaui-active-blue-80: #6BBEFF;--geaui-active-blue-75: #8CCDFF;--geaui-active-blue-70: #94D0FF;--geaui-active-blue-65: #B0DDFF;--geaui-grey-07: #282828;--geaui-grey-08: #3C3C3C;--geaui-grey-09: #646464;--geaui-grey-10: #787878;--geaui-grey-11: #A0A0A0;--geaui-grey-12: #B4B4B4;--geaui-grey-13: #FAFBFC;--geaui-tertiary-red: #57021D;--geaui-tertiary-red-90: #750E13;--geaui-tertiary-red-70: #DB1E28;--geaui-tertiary-red-50: #FF767C;--geaui-tertiary-red-40: #FFA4A9;--geaui-tertiary-green: #0A3D1B;--geaui-tertiary-green-90: #0D5C2B;--geaui-tertiary-green-70: #129C4D;--geaui-tertiary-green-50: #18DD6E;--geaui-tertiary-green-40: #53F99B;--geaui-tertiary-yellow: #5F5407;--geaui-tertiary-yellow-90: #917D05;--geaui-tertiary-yellow-80: #C5A703;--geaui-tertiary-yellow-70: #F2CB00;--geaui-tertiary-yellow-50: #FFE45B;--geaui-tertiary-yellow-40: #FFEA7F;--geaui-radiant-orange-90: #D65A00;--geaui-radiant-orange-80: #F36600;--geaui-radiant-orange-60: #FF8832;--geaui-radiant-orange-50: #FBA05E;--geaui-radiant-orange-40: #FEB580;--geaui-radiant-orange-20: #FAB301;--geaui-energetic-pink-120: #E842E8;--geaui-energetic-pink-110: #FF57FF;--geaui-energetic-pink-90: #FF8DFF;--geaui-energetic-pink-80: #FFA3FF;--geaui-energetic-pink-70: #FFB0FF;--geaui-active-green-90: #4AFF9B;--geaui-active-green-80: #7DFFB7;--geaui-active-green-70: #C8FFE0;--geaui-gradient-activegreen: linear-gradient(180deg, #001664 8.33%, #1AFF80 100%);--geaui-gradient-dailypink: linear-gradient(225.69deg, #FF80FF 0%, #FF80FF 15.63%, #391EC7 68.23%, #0303B8 100%);--geaui-night-blue-100: #000C34;--geaui-pure-white-brightness-30: rgba(255, 255, 255, .3);--geaui-gradient-energetic-pink: linear-gradient(153deg, #C239E3 16.67%, #EBBDF6 100%);--geaui-gradient-active-blue: linear-gradient(153deg, #3087F1 16.67%, #BAD7FA 100%);--geaui-gradient-green: linear-gradient(153deg, #1A7573 16.67%, #E6F0EF 100%);--geaui-gradient-vibrant-blue: linear-gradient(153deg, #0303B8 16.67%, #B3B3EA 100%);--geaui-gradient-midnight-blue: linear-gradient(155deg, #1A2754 15.99%, #B3B7C6 99.04%);--geaui-gradient-pink-blue: linear-gradient(#FF80FF, #391EC7, #0303B8);--geaui-background-vibrant-blue: #9A9AE3;--geaui-background-green: #80B3B1;--geaui-background-pink: #E4A7F3;--geaui-background-grey: #999FB3;--geaui-background-active-blue: #A3CAF9}.header-container{width:100%}.flex-1{flex:1;display:flex}.contact-form-side-modal{position:fixed;top:60px;right:0;width:fit-content;z-index:10;height:calc(100% - 60px)}.header-toolbar-container{border-radius:0;background-color:var(--geaui-night-blue);padding:0 8px;height:60px;display:flex;justify-content:space-between;font-size:14px;font-family:GEA Inter SemiBold,Arial,sans-serif;position:sticky;width:100%;z-index:30;top:0}.header-toolbar-container .menu-container{display:flex;width:200px;justify-content:flex-start;align-items:center;padding-left:10px}.header-toolbar-container .menu-container .menu-icon{width:40px;height:40px;font-size:40px}.header-toolbar-container .menu-container .burger-icon-hover:hover{cursor:pointer}.header-toolbar-container .menu-container .logo{height:20px;margin-left:22px;cursor:pointer}.header-toolbar-container .menu-container .default-logo-letter{font-family:GEA Sans,Arial,sans-serif;font-weight:700;color:var(--geaui-white);font-size:40px;margin-left:47.5px}.header-toolbar-container .menu-container .drawer{transform:scale(.6)}.header-toolbar-container .environment-container{display:flex;align-items:center}.header-toolbar-container .title-container{display:flex;flex:1;justify-content:center;align-items:center;color:var(--geaui-white);font-size:16px;font-weight:600}.header-toolbar-container .settings-container{display:flex;justify-content:flex-end;align-items:center;justify-items:flex-end;color:var(--geaui-white);height:100%}.header-toolbar-container .settings-container .language-select{margin-right:10px;background-color:var(--geaui-night-blue);width:auto}.header-toolbar-container .settings-container .language-select ::ng-deep .mat-select-value{margin-right:5px}.header-toolbar-container .settings-container .language-select ::ng-deep .mat-select-value .mat-select-arrow{color:var(--geaui-white)}.header-toolbar-container .settings-container .login{background-color:var(--geaui-night-blue);color:var(--geaui-white)}.header-toolbar-container .settings-container #signup{margin-right:-5px}.header-toolbar-container .settings-container .loginText{margin-left:7px}.header-toolbar-container .settings-container #userMenu{margin-left:28px;width:120px!important}.header-toolbar-container .settings-container .user-button{color:var(--geaui-white);background-color:var(--geaui-night-blue);margin:0 15px;display:flex;align-items:center;gap:10px;cursor:pointer}.header-toolbar-container .settings-container .user-button.admin-background{padding:8px;border-radius:4px;background-color:var(--geaui-tertiary)}.header-toolbar-container .settings-container .bell{margin-left:36.44px;margin-right:13px;transform:scale(.95)}.header-toolbar-container .settings-container #userIcon{margin-right:12px}.header-toolbar-container .settings-container ::ng-deep .arrow svg path{stroke:var(--geaui-white)}.header-toolbar-container .logo-container{display:flex;justify-content:center;height:20px;margin-left:16px}.header-toolbar-container .logo-container .mobile-logo{cursor:pointer;height:20px}.header-toolbar-container mat-icon{cursor:pointer}.loginIcon{transform:scale(.8)}#logoutText{margin-right:10px;font-family:GEA Inter Medium,Arial,sans-serif}.user-menu-item{display:flex;align-items:center;padding:8px 15px;color:var(--geaui-primary-black)}.user-menu-item .user-menu-item-warning-icon{margin-right:6px;width:16px;height:16px}.user-menu-item:hover{background-color:#4f4fcd66;border-radius:4px;cursor:pointer}.user-menu-item.text{cursor:default}.user-menu-item.login-item{display:flex;flex-direction:row;align-items:center}.user-menu-item.login-item .login-icon{margin-right:8px}.logged-in-settings{display:flex;align-items:center;height:100%}.logged-in-settings .shopping-cart{margin-right:16px;display:flex;justify-content:center;align-items:center;cursor:pointer;background-color:var(--geaui-primary);height:100%;padding-right:12px;padding-left:12px}.logged-in-settings .shopping-cart .badge{background-color:#ff80ff;border-radius:4px;height:19px;line-height:16px;min-width:16px;padding:2px 4px;margin-left:10px;text-align:center;color:var(--geaui-primary-black);font-size:12px}.logged-in-settings .shopping-cart:hover{background-color:var(--geaui-primary-hover)}.logged-in-settings .shopping-cart:active{background-color:var(--geaui-primary-pressed)}.user-menu-item:disabled{background-color:var(--geaui-grey-06);color:var(--geaui-grey-01);pointer-events:unset}.user-menu-divider{border-top:2px solid var(--geaui-grey-03);width:85%;margin-top:12px;margin-bottom:12px;margin-left:15px}.header-menu{background-color:var(--geaui-grey-06);min-width:220px;overflow:scroll;padding:10px 15px;margin-left:-15px;display:flex;flex-direction:column;position:absolute;gap:8px;top:60px;right:8px;box-shadow:0 0 14px #0000001a}.header-menu .user-menu-icon{padding:15px 8px;margin:10px}.settings-container .gea-header-notification-icon{position:relative;top:8px}.menu-item-text-wrapper{display:inline-block;vertical-align:middle;font-size:16px;font-family:GEA Inter Medium,Arial,sans-serif}.mobile-sidebar-icon{margin-left:12px;cursor:pointer}geaui-notifications-count{display:flex}.burger-menu-container{position:absolute;left:10px;z-index:1000;width:410px;background-color:#f5f5f5;box-shadow:0 8px 16px #14141414}.burger-menu-container .burger-menu-app-count{color:var(--geaui-black);font-size:20px;line-height:130%;margin:24px 24px 0}.burger-menu-container .available-apps-container{display:flex;flex-wrap:wrap;padding:32px 24px 24px;gap:16px}.burger-menu-container .available-apps-container .app-container{display:flex;justify-content:center;flex-direction:column;align-items:center;text-align:center;width:110px;color:var(--geaui-black);row-gap:8px;padding:8px;text-decoration:none}.burger-menu-container .available-apps-container .app-container:hover{background-color:#4f4fcd66;border-radius:10px;cursor:pointer}.burger-menu-container .available-apps-container .app-container .app-icon{width:64px}.burger-menu-container .available-apps-container .app-container .app-description{font-size:14px;height:60px;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:3;overflow:hidden;text-overflow:ellipsis;line-height:140%;width:100%;overflow-wrap:break-word;hyphens:none;-moz-hyphens:none}.mobile-container .user-menu-icon{margin-right:12px;margin-left:24px;cursor:pointer}.mobile-container .menu-container{width:unset}.mobile-profile{background-color:var(--geaui-grey-06);height:calc(100vh - 60px);position:absolute;width:100%;z-index:6}.mobile-user-name{font-size:20px;font-weight:500;line-height:130%;padding-top:26px;padding-bottom:16px;padding-left:24px;display:block}.mobile-menu-items{display:flex;flex-direction:column}.mobile-menu-items .mobile-user-menu-item{cursor:pointer;font-size:14px;font-weight:500;line-height:130%;display:block;margin-top:16px;margin-bottom:16px;margin-left:24px}.mobile-menu-items .mobile-user-menu-item.logout{display:flex;flex-direction:row;align-items:center}.mobile-menu-items .mobile-user-menu-item.logout #mobileLogoutText{margin-left:8px}.mobile-signup-container{display:flex;flex-direction:column;align-items:center}.mobile-signup-container .mobile-login-button{width:100%;padding:40px 20px 0}.mobile-signup-container .singup-question{margin-top:40px}.mobile-signup-container .mobile-signup-button{padding-top:16px}\n"]
    }]
  }], () => [{
    type: i1.TranslateService
  }, {
    type: i2.BreakpointObserver
  }, {
    type: i3.Router
  }, {
    type: i4.ResourcesService
  }, {
    type: i0.NgZone
  }, {
    type: i5.GoogleAnalyticsService
  }, {
    type: i6.Store
  }, {
    type: i4.NavigationService
  }, {
    type: i6.Actions
  }, {
    type: i4.HeaderUtilService
  }, {
    type: i4.ImageService
  }, {
    type: i4.PermissionService
  }, {
    type: i7.LoginService
  }, {
    type: i4.MonitoringService
  }, {
    type: i8.InactivityService
  }, {
    type: i9.ComplexDialogV2Service
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: i10.MsalAuthFacadeService
  }, {
    type: i9.ErrorHandlerV2Service
  }, {
    type: i11.ContactFormService
  }, {
    type: i0.DestroyRef
  }, {
    type: i12.SystemMessageService
  }, {
    type: i13.HeaderNgxsService
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: ['portalLink']
    }]
  }], {
    redirectOnLogout: [{
      type: Input
    }],
    noAuth: [{
      type: Input
    }],
    canOpenBurgerMenu: [{
      type: Input
    }],
    googleAnalyticsActivated: [{
      type: Input
    }],
    headerTitle: [{
      type: Input
    }],
    showBanner: [{
      type: Input
    }],
    showLangDropdown: [{
      type: Input
    }],
    shoppingCartUrl: [{
      type: Input
    }],
    shoppingCartBadge: [{
      type: Input
    }],
    disableSignupMobile: [{
      type: Input
    }],
    disableLoginMobile: [{
      type: Input
    }],
    isAdmin: [{
      type: Input
    }],
    closeAllMenus: [{
      type: HostListener,
      args: ['document:click', ['$event']]
    }]
  });
})();
